<template>
    <tw-modal
        ref="modal"
    >
        <template v-slot:content>
            <div class="w-full px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                <div class="w-full sm:flex sm:items-start">
                    <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-blue-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                        <!-- Heroicon name: outline/exclamation -->
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                        </svg>
                    </div>
                    <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                            Upload a File
                        </h3>
                        <div class="mt-2">
                            <ul>
                                <li
                                    class="text-sm text-red-600"
                                    :class="{'hidden': !errorMessages.length}"
                                    v-for="(error, index) in errorMessages"
                                    :key=index
                                >
                                    {{ error }}
                                </li>
                            </ul>
                            <div class="grid grid-cols-3 gap-2 mt-4">
                                <p class="col-span-2 control">
                                    <input
                                        name="file_name"
                                        class="block w-full min-w-0 border-gray-300 rounded-md sm:text-sm focus:ring-blue-500 focus:border-blue-500"
                                        type="text"
                                        v-model="form.file_name"
                                        required
                                    >
                                    <span
                                        v-if="form.errors.has('file_name')"
                                        class="help is-danger"
                                    >{{ form.errors.first('file_name') }}</span>
                                </p>
                                <label class="col-span-1 file-label">
                                    <span
                                        class="tw-button-gray"
                                        @click="openFileDialog()"
                                    >
                                        Select File...
                                    </span>
                                </label>
                                <input
                                    v-show="false"
                                    name="file"
                                    class="input"
                                    ref="file"
                                    type="file"
                                    @change="addFile($event)"
                                >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="flex justify-end px-4 py-3 space-x-2 sm:space-x-4 bg-gray-50 sm:px-6">
                <button
                    class="tw-button-gray"
                    type="button"
                    @click="closeModal"
                    :disabled="loading"
                >{{ trans('app.cancel').titleCase() }}</button>

                <button
                    type="button"
                    class="tw-button-green space-x-1.5"
                    @click="submit"
                    :disabled="! hasSelectedFile"
                >
                    <span>{{ trans('app.submit').titleCase() }}</span>
                     <svg
                        v-if="loading"
                        class="w-5 h-5 animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                </button>
            </div>
        </template>

        <footer slot="footer">
            <button
                class="tw-button-gray"
                type="button"
                @click="closeModal"
                :disabled="loading"
            >{{ trans('app.cancel').titleCase() }}</button>

            <button
                type="button"
                 class="tw-button-green space-x-1.5"
                @click="submit"
                :disabled="! hasSelectedFile"
            >
                <span>{{ trans('app.submit').titleCase() }}</span>
                <svg
                    v-if="loading"
                    class="w-5 h-5 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                </svg>
            </button>
        </footer>
    </tw-modal>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    data () {
        return {
            loading: false,
            form: new Form({
                file_name: '',
                file: null,
                project_id: null,
            }),
            type: null,
            type_id: null,
            errorMessages: {},
        };
    },

    computed: {
        actionRoute () {
            return this.route('files.store', {type: this.type, type_id: this.type_id});
        },

        hasSelectedFile () {
            if (! this.form.file) {
                return false;
            }

            return true;
        }
    },

    listeners: {
        'open-file-upload-modal' (type, type_id, project_id = null) {
            this.type = type;
            this.type_id = type_id;
            this.form.project_id = project_id;

            this.showModal();
        },
    },

    methods: {
        openFileDialog() {
            this.$refs.file.click();
        },

        showModal () {
            this.$refs.modal.show();
        },

        closeModal () {
            this.$refs.modal.hide();
            this.form.reset();
            this.type = null;
            this.type_id = null;
        },

        addFile () {
            this.form.file = this.$refs.file.files[0];
            if (this.form.file_name === '') {
                this.form.file_name = this.form.file.name;
            }
        },

        async submit () {
            try {
                this.loading = true;

                if (! this.form.file) {
                    delete this.form.file;
                }

                await this.form.post(this.actionRoute);

                OSPEvent.$emit('files-updated', {type: this.type, type_id: this.type_id});

                this.closeModal();
            } catch (error) {
                this.form.record(error.response.data.errors);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
